import React, { useContext } from 'react'
import { isMobile } from 'react-device-detect'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import { SkyInformationPopover } from './SkyPopover'
import DoneIcon from '@material-ui/icons/Done'
import FlexView from 'react-flexview/lib'
import CloseIcon from '@material-ui/icons/Close'
import './LiabilityCoveragePopover.css'
import { isUK } from '../../../services/utils'
var classNames = require('classnames')

export const LiabilityCoveragePopover = (props) => {
  let insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
  const { value, factor } = FirebaseService.getObject(
    FirebaseConfigKey.LIABILITY_DEDUCTIBLE
  )
  const sign =
    factor == 'currency'
      ? FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)
      : '%'
  return (
    <SkyInformationPopover eventId={'liability'}>
      <div
        className={classNames('text-body', 'bold', {
          black: !isMobile,
          white: isMobile,
        })}>
        Liability Coverage Includes:
      </div>
      <div className="margin-top-basic">
        {FirebaseService.getObject(FirebaseConfigKey.LIABILITY_COVERAGE_TEXT)[
          'general'
        ].map((text, index) => (
          <FlexView
            vAlignContent={'center'}
            className={classNames('text-small', 'margin-top-6', {
              black: !isMobile,
              white: isMobile,
            })}
            key={index}>
            <DoneIcon
              fontSize="small"
              className={classNames({
                green: !isMobile,
                white: isMobile,
              })}
            />{' '}
            <span className="margin-left-6">{text}</span>
          </FlexView>
        ))}

        {FirebaseService.getObject(FirebaseConfigKey.LIABILITY_COVERAGE_TEXT)[
          'onlyWithHull'
        ].map((text, index) => (
          <FlexView
            vAlignContent={'center'}
            className={classNames('text-small', 'margin-top-6', {
              black: !isMobile,
              white: isMobile,
            })}
            key={index}>
            {(insurancePurchaseContext.drones.length > 0 ||
              insurancePurchaseContext.selectedOption.dronePremium) > 0 ? (
              <DoneIcon
                fontSize="small"
                className={classNames({
                  green: !isMobile,
                  white: isMobile,
                })}
              />
            ) : (
              <CloseIcon
                fontSize="small"
                className={classNames({
                  red: !isMobile,
                  white: isMobile,
                })}
              />
            )}
            <span className="margin-left-6">{text}</span>
          </FlexView>
        ))}
      </div>
      {!isUK() && (
        <div className="text-small box liability-deductible-poppver">
          Deductibles: {sign}
          {value}
        </div>
      )}
    </SkyInformationPopover>
  )
}
